import React, { useState } from "react";
import { Pane, BoxButton, Icon, CDialog } from "shared";
import { GetApp } from "@material-ui/icons";
import { MessageHistoryForm } from "./MessageHistoryForm";

interface Props {
  mode: "patient" | "therapist";
  contextId: number;
}

export const MessageHistory: React.VFC<Props> = ({ mode, contextId }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div style={{ marginTop: 16 }}>
      <Pane>
        <BoxButton startIcon={<Icon of={GetApp} />} onClick={() => setOpen(true)}>
          Fetch Message History
        </BoxButton>
      </Pane>

      <CDialog title="Export Message History" maxWidth="sm" fullWidth open={isOpen} onClose={() => setOpen(false)}>
        <MessageHistoryForm mode={mode} contextId={contextId} onClose={() => setOpen(false)} />
      </CDialog>
    </div>
  );
};
